export default "__VITE_PUBLIC_ASSET__998f5339__"